import { defineComponent, ref, onMounted, nextTick, onBeforeMount, reactive, onUpdated } from 'vue';
import { useToggle } from '@vueuse/core';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex'
import { queryMedia } from '@/utils';
import {
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
} from '@ant-design/icons-vue';
import './default.less';
import { Asider, Header } from '@/components/layout';

export default defineComponent({
  components: {
    'layout-asider': Asider,
    'layout-header': Header,
    UserOutlined,
    VideoCameraOutlined,
    UploadOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
  },
  setup() {
    const [collapsed, toggleSider] = useToggle(false);
    const [visible, toggleDrawer] = useToggle(false);
    const route = useRoute()

    // 手机端展示不同的菜单
    const isMobile = ref<boolean>(false);
    // queryMedia((data: string) => {
    //   isMobile.value = data === 'xs';
    // });

    // 展示和收起菜单
    const toggle = () => {
      isMobile.value ? toggleDrawer() : toggleSider();
    };

    return () => (
      <>
        {
          route.meta.showLayout !== false ?
          <a-layout id="layout" class={isMobile.value ? 'mobile' : 'desk'}>
            {
              isMobile.value ? (
                <a-drawer
                  class="layout-drawer"
                  placement="left"
                  closable={false}
                  v-model={[visible.value, 'visible']}
                >
                  <layout-asider collapsed={false}></layout-asider>
                </a-drawer>
              ) : (
                <a-layout-sider
                  class="layout-asider"
                  v-model={[collapsed.value, 'collapsed']}
                  breakpoint="md"
                  width={256}
                  trigger={null}
                  collapsible
                >
                  <layout-asider collapsed={collapsed.value}></layout-asider>
                </a-layout-sider>
              )
            }

            <a-layout>
              <layout-header collapsed={collapsed.value} onToggle={toggle}></layout-header>
              {/* <visited-tags></visited-tags> */}
              <div class="scrollbar-wrap">
                <a-layout-content class="flex-1">
                  <div class={['common-layout-content', {'doc-page': route.meta?.isDoc}]}>
                    <router-view></router-view>
                  </div>
                  <div class="copyright">
                    { `© 2012 - ${new Date().getFullYear()} Dida Travel`  }
                  </div>
                </a-layout-content>
              </div>
            </a-layout>
          </a-layout> :
          <router-view></router-view>
        }
      </>  
    );
  },
});
